import React, { ReactNode } from 'react';
import { Dropdown, DropdownButton } from '@shared/components/dropdown';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { MBTextBody1 } from '../typography';
import { List } from './List';
import { SortOption } from './types';

interface Props {
  buttonLabel?: ReactNode;
  direction?: API.SortDirection;
  onSelect(direction: API.SortDirection): void;
  buttonStyle?: React.CSSProperties;
  showDownArrow?: boolean;
  sortOptions?: SortOption[];
}

const defaultSortOptions: SortOption[] = [
  {
    id: 'ASC',
    label: i18n('card.actions.sort.ascending'),
    icon: 'arrow-full-up',
    direction: 'ASC',
  },
  {
    id: 'DESC',
    label: i18n('card.actions.sort.descending'),
    icon: 'arrow-full-down',
    direction: 'DESC',
  },
];

export function SortOptionsDropdown({
  direction,
  onSelect,
  buttonLabel,
  buttonStyle,
  showDownArrow,
  sortOptions = defaultSortOptions,
}: Props) {
  const selectedOption = sortOptions.find(option => option.id === direction);
  return (
    <Dropdown
      button={({ onClick, isOpen }) => (
        <DropdownButton
          onClick={onClick}
          open={isOpen}
          style={buttonStyle}
          showDownArrow={showDownArrow}
        >
          {buttonLabel ?? <MBTextBody1 numberOfLines={1}>{selectedOption?.label}</MBTextBody1>}
        </DropdownButton>
      )}
      closeOnSelect
    >
      <List
        showSearch={false}
        options={sortOptions}
        selected={selectedOption}
        onSelect={option => onSelect(option.id as API.SortDirection)}
      />
    </Dropdown>
  );
}
